import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './../../scss/bankId-login.scss';
import BankIDAuth from '../../components/bank-id-auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { selectIsQRModalOpen , selectToggleReactivate } from '../../features/bankid/bankid.selectors';
interface LoginWithBankIdProps {
    onSuccess?: (userData: any) => void;
    onClose?: () => void;
}

const LoginWithBankId: React.FC<LoginWithBankIdProps> = ({ onSuccess, onClose }) => {
    const { t } = useTranslation();
    const isQRModalOpen = useSelector(selectIsQRModalOpen);
    let toggleReactivate = useSelector(selectToggleReactivate);

    const handleSuccess = (userData: any) => {
        if (onSuccess) {
            onSuccess(userData);
        }
    };
    
    useEffect(() => {
        if (toggleReactivate) {
            handleClose();
        }
    }, [toggleReactivate]);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <BankIDAuth
            mode="login"
            onSuccess={handleSuccess}
            onClose={handleClose}
            className="login-theme"
            title={t('SIGNING_IN_WITH_BANK_ID')}
        />
    );
};

export default LoginWithBankId;
